import { FC, useState } from 'react';
import { Button, ButtonStyles, Icons } from '@silverfort/sf-components';
import PoliciesDashboardsDisclaimers from '../../../../components/PoliciesDashboardsDisclaimers/PoliciesDashboardsDisclaimers';
import { Popover } from '@material-ui/core';

const DISCLAIMERS = [
    'The data on this page represents human users blocked by Silverfort’s Authentication Firewall.',
    'Data reflects the selected timeframe. Clicking a metric will redirect you to the Authentication Logs screen, filtered to match. Some logs may be missing if they fall outside your configured log retention window.',
    'Pie chart metrics show the distribution of denied activity types for human users, based on logs from the selected timeframe.'
];

const Disclaimers: FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setIsOpen(true);
    };

    const handlePopoverClose = () => {
        setIsOpen(false);
        setAnchorEl(null);
    };

    return (
        <>
            <Button iconLeft={Icons.CircleInfo} buttonStyle={ButtonStyles.Primary} onClick={handleButtonClick} />
            <Popover
                open={isOpen}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                classes={{
                    root: 'z-[10000]',
                    paper: 'my-0.5 mx-[-8px] shadow-[0px_4px_8px_0px_#0000001A] rounded-[8px] border border-sf-gray-100'
                }}>
                <PoliciesDashboardsDisclaimers
                    title="Information"
                    disclaimers={DISCLAIMERS}
                    onClose={handlePopoverClose}
                />
            </Popover>
        </>
    );
};

export default Disclaimers;
